import { FC } from "react";
import { useTranslation } from "next-i18next";
import {
  IFormValues,
  IPaymentOfferModel,
  IPaymentOrderModel,
  IUserSubscriptionModel,
} from "@nf/common";
import CheckMark from "../../resources/icons/payments/checkmark-round.svg";
import cx from "classnames";
import dynamic from "next/dynamic";
const OfferPrice = dynamic<any>(() =>
  import("./CardComponents/OfferPrice").then((mod) => mod.OfferPrice)
);
const OldPrice = dynamic<any>(() =>
  import("./CardComponents/OldPrice").then((mod) => mod.OldPrice)
);

import { ButtonContainer } from "./CardComponents/ButtonContainer";

export interface IOfferCardProps {
  offer: IPaymentOfferModel;
  isLoading?: boolean;
  sendPaymentOrder: (
    formValues?: IFormValues,
    paymentMethodId?: number,
    voucher?: boolean
  ) => void;
  error?: boolean;
  active?: boolean;
  withoutButton?: boolean;
  buttonCallbackAction?: () => void;
  handleSelect?: (offerId: string) => void;
  handleReedem?: (offerId: string) => void;
  paymentOrder?: IPaymentOrderModel;
  subscription?: IUserSubscriptionModel;
  displaySavingLabel?: boolean;
  showOldPriceField?: boolean;
  showVoucherLabel?: boolean;
  displayMode?: "choose" | "change";
}

const isAnnualPeriod = (period: string) => period === "year";

const SavingLabel: FC<{ period: string; displayLabel: boolean }> = ({
  period,
  displayLabel = false,
}) => {
  const { t } = useTranslation("translations");
  return isAnnualPeriod(period) && displayLabel ? (
    <div className={"annualSave"}>
      {t("web_choose_subscription_annual_save", "")}
    </div>
  ) : null;
};

export const SimpleOfferCard = ({
  offer,
  paymentOrder,
  handleSelect,
  active,
  withoutButton,
  subscription,
  displaySavingLabel = false,
  showOldPriceField = true,
  showVoucherLabel = true,
  buttonCallbackAction,
  displayMode = "choose",
  sendPaymentOrder,
}: IOfferCardProps) => {
  return (
    <div
      className={cx(
        "OfferContainer",
        active && "active",
        !withoutButton && "clickable"
      )}
      onClick={() => !!handleSelect && handleSelect(offer.Id)}
    >
      <SavingLabel period={offer.Period} displayLabel={displaySavingLabel} />

      {showOldPriceField && (
        <OldPrice
          subscription={subscription}
          paymentOrder={paymentOrder}
          offer={offer}
        />
      )}

      <OfferPrice
        subscription={subscription}
        paymentOrder={paymentOrder}
        offer={offer}
      />

      {!withoutButton && (
        <>
          <ButtonContainer
            offer={offer}
            displayMode={displayMode}
            active={active}
            buttonCallbackAction={buttonCallbackAction}
            sendPaymentOrder={sendPaymentOrder}
          />
        </>
      )}

      {!!paymentOrder?.CouponCode && showVoucherLabel && (
        <div className={"VoucherSuccess"}>
          <span>
            <CheckMark />
            {paymentOrder?.CouponCode}
          </span>
        </div>
      )}
    </div>
  );
};
